import React, {useEffect, useRef, useState} from "react";
import moment from "moment";
import {useLocaleContext} from "../../../../context/LocaleContext";
import "./style.scss";

const className = 'stream-player-overlay-timeout';

const TimeoutSection = ({$locale, value, titles, emptyVisible = true, divider = ':', zerofill = 2}) => {

    if ((!value || value <= 0) && !emptyVisible) {
        return null;
    }

    let valueParts = value.toString().split('');
    if (zerofill > valueParts.length) {
        valueParts = '0'.repeat(zerofill - valueParts.length).split('').concat(valueParts);
    }
    valueParts = valueParts.map((value) => parseInt(value));
    let lastValue = valueParts[valueParts.length - 1];
    if (valueParts.length > 1 && valueParts[valueParts.length - 2] === 1) {
        lastValue += 10;
    }
    let title;
    if (lastValue >= 5 || lastValue === 0) {
        title = titles[2]
    } else if (lastValue >= 2) {
        title = titles[1];
    } else {
        title = titles[0];
    }

    return (
        <div className={`${className}-section`}>
            <div>
                {valueParts.map((part, index) => (
                    <span key={index} className={`${className}-number`}>{part}</span>
                ))}
                {divider && <span className={`${className}-divider`}>{divider}</span>}
            </div>
            <label>{$locale.get(title)}</label>
        </div>
    );
}

export default ({
    time = moment(),
    onTimeoutOver,
    emptyVisibleDay = false,
    isVisibleSeconds = true,
}) => {
    const $locale = useLocaleContext();
    const [duration, setDuration] = useState(moment.duration(time.diff(moment()) < 0 ? 0 : time.diff(moment())));
    const timerRef = useRef(null);

    useEffect(() => {
        const updateDuration = () => {
            const diff = time.diff(moment());

            if (diff < 0) {
                clearInterval(timerRef.current);

                if (onTimeoutOver) {
                    onTimeoutOver();
                }
            } else {
                setDuration(moment.duration(diff));
            }
        }

        timerRef.current = setInterval(updateDuration, 1000);
        updateDuration();

        return () => {
            clearInterval(timerRef.current);
        }
    }, [time]);

    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const days = Math.floor((duration.asSeconds() - hours*3600 - minutes*60 - seconds) / (3600*24));

    return (
        <div className={className}>
            <TimeoutSection
                $locale={$locale}
                value={days}
                emptyVisible={emptyVisibleDay}
                zerofill={0}
                titles={['timeout.day.1', 'timeout.day.2', 'timeout.day.5']}
            />
            <TimeoutSection
                $locale={$locale}
                value={hours}
                titles={['timeout.hour.1', 'timeout.hour.2', 'timeout.hour.5']}
            />
            <TimeoutSection
                $locale={$locale}
                value={minutes}
                titles={['timeout.minute.1', 'timeout.minute.2', 'timeout.minute.5']}
                divider={!isVisibleSeconds ? '' : undefined}
            />
            {isVisibleSeconds && (
                <TimeoutSection
                    $locale={$locale}
                    value={seconds}
                    divider={''}
                    titles={['timeout.second.1', 'timeout.second.2', 'timeout.second.5']}
                />
            )}
        </div>
    );
}
